import React, { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { useLocation } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import APPROVE_ATTENDANCE from '../../graphql/event/mutation/approve-attendance';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ApproveAttendancePage = () => {
  const query = useQuery();
  const token = query.get('token');
  const [approve] = useMutation(APPROVE_ATTENDANCE);
  const [status, setStatus] = useState('processing');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (token) {
        approve({ variables: { token } })
            .then(() => setStatus('success'))
            .catch((error) => {
                // Extract the actual error message from Apollo error
                const msg = error?.graphQLErrors?.[0]?.message 
                    || error?.message 
                    || 'Your confirmation could not be processed. Please try again or contact support.';
                setErrorMessage(msg);
                setStatus('error');
            });
    } else {
        setStatus('no-token');
    }
  }, [token, approve]);

  return (
    <Container maxWidth="sm">
      <Box mt={10} textAlign="center">
        {status === 'processing' && (
            <>
                <Typography variant="h5">Processing Approval...</Typography>
                <Box mt={2}><CircularProgress /></Box>
            </>
        )}
        {status === 'success' && (
            <Typography variant="h5" style={{ color: 'green' }}>
                Attendance Approved! 
                <br/>
                You have officially joined the event.
            </Typography>
        )}
        {status === 'error' && (
             <>
                <Typography variant="h5" color="error" gutterBottom>
                    Approval Failed
                </Typography>
                <Typography variant="body1" style={{ maxWidth: 480, margin: '0 auto' }}>
                    {errorMessage}
                </Typography>
            </>
        )}
        {status === 'no-token' && (
             <Typography variant="h5" color="error">
                Invalid Link (No Token)
            </Typography>
        )}
      </Box>
    </Container>
  );
};

export default ApproveAttendancePage;
